import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudApi,
  CrudOption,
} from "../../comp/crud";
import { TextCell } from "../../comp/cell";
import { ApiClient, displayMortgageLoanType } from "../../api/ApiClient";
import React, { useContext, useEffect, useState, useRef } from "react";
import { formatRelativeTime, formatAmountZhCn } from "../../utils";
import { Button, Tag } from "@douyinfe/semi-ui";

export interface PlanRepaymentReportDetailProps {
  leadId?: number;
  reportType?: string;
}

export default function PlanRepaymentReportDetail(
  props: PlanRepaymentReportDetailProps
) {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [currentReqUrl, setCurrentReqUrl] = useState("");

  let apiClient = ApiClient.getDefault();
  //获取当前月份
  let now = new Date();
  let month = now.getMonth() + 1;

  const getNextMonth = (index: number) => {
    let nextMonth = month + index > 12 ? month + index - 12 : month + index;
    return nextMonth;
  };

  let cols: Col[] = [
    {
      name: "贷款ID",
      key: "loanId",
      width: 60,
      type: ColType.STRING,
      showInFilter: false,
    
     
    },
     {
      name: "贷款平台",
      key: "platform",
      width: 200,
      type: ColType.STRING,
      showInFilter: false,
     
     
    },
    
    {
      name: "贷款类型",
      key: "loanType",
      width: 70,
      type: ColType.SELECT,
      showInFilter: false,
      render: (value, record, index) => {
        return displayMortgageLoanType(value);
      },
    },
    {
      name: "贷款金额",
      key: "loanAmount",
      width: 70,
      showInFilter: false,
      optional: true,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "已还金额",
      optional: true,
      key: "paidAmount",
      width: 70,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "待还金额",
      optional: true,
      hideInList: true,
      key: "unpaidAmount",
      width: 70,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "待还计划数",
      optional: true,
      key: "repaymentPlan",
      width: 80,
      type: ColType.STRING,
    },
    {
      name: "最近还款日",
      optional: true,
      key: "latestDueDate",
      width: 80,
      type: ColType.STRING,
    },
    {
      name: "账单日",
      key: "billDay",
      width: 70,
      colSort: 4,
      type: ColType.STRING,
    },
    {
      name: month + "月",
      key: "month1Amount",
      width: 130,
      colSort: 5,
      type: ColType.NUMBER,
      render: (value, record, index) => {
              return (<>
                <Tag color="white">{formatAmountZhCn(record.month1Amount)}</Tag>
                <Tag color="green" style={{ marginLeft: 10 ,fontSize:14 }}>{formatAmountZhCn(record.month1PaidAmount)}</Tag>
                </>
              );
            },
    },
    {
      name: getNextMonth(1) + "月",
      key: "month2Amount",
      width: 130,
      colSort: 5,
      type: ColType.NUMBER,
      render: (value, record, index) => {
              return (<>
                <Tag color="white">{formatAmountZhCn(record.month2Amount)}</Tag>
                <Tag color="green" style={{ marginLeft: 10 ,fontSize:14 }}>{formatAmountZhCn(record.month2PaidAmount)}</Tag>
                </>
              );
            },
    },
    {
      name: getNextMonth(2) + "月",
      key: "month3Amount",
      width: 130,
      colSort: 5,
      type: ColType.NUMBER,
      render: (value, record, index) => {
              return (<>
                <Tag color="white">{formatAmountZhCn(record.month3Amount)}</Tag>
                <Tag color="green" style={{ marginLeft: 10 ,fontSize:14 }}>{formatAmountZhCn(record.month3PaidAmount)}</Tag>
                </>
              );
            },
    },
    {
      name: getNextMonth(3) + "月",
      key: "month4Amount",
      width: 130,
      colSort: 5,
      type: ColType.NUMBER,
      render: (value, record, index) => {
              return (<>
                <Tag color="white">{formatAmountZhCn(record.month4Amount)}</Tag>
                <Tag color="green" style={{ marginLeft: 10 ,fontSize:14 }}>{formatAmountZhCn(record.month4PaidAmount)}</Tag>
                </>
              );
            },
    },
    {
      name: getNextMonth(4) + "月",
      key: "month5Amount",
      width: 130,
      colSort: 5,
      type: ColType.NUMBER,
      render: (value, record, index) => {
              return (<>
                <Tag color="white">{formatAmountZhCn(record.month5Amount)}</Tag>
                <Tag color="green" style={{ marginLeft: 10 ,fontSize:14 }}>{formatAmountZhCn(record.month5PaidAmount)}</Tag>
                </>
              );
            },
    },
    {
      name: getNextMonth(5) + "月",
      key: "month6Amount",
      width: 130,
      colSort: 5,
      type: ColType.NUMBER,
      render: (value, record, index) => {
              return (<>
                <Tag color="white">{formatAmountZhCn(record.month6Amount)}</Tag>
                <Tag color="green" style={{ marginLeft: 10 ,fontSize:14 }}>{formatAmountZhCn(record.month6PaidAmount)}</Tag>
                </>
              );
            },
    },
  ];

  useEffect(() => {}, []);

  const actions: CrudAction[] = [];

  const initParams = {
    leadId: props.leadId,
    paidMethod: props.reportType == "PlanRepaymentReportAgent" ? "DH" : "KHZH",
  };

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          flex: 1,
          overflow: "auto", // 关键：启用滚动
        }}
      >
        <Crud
          getCrudApi={(crudApi) => {
            setCrudApi(crudApi);
          }}
          params={initParams}
          actions={actions}
          select={false}
          canExport={true}
          name="月待还款明细"
          entityKey="mortgageLoanReport/loanDetail"
          pageSize={150}
          rowActionWidth={60}
          cols={cols}
        />
      </div>
    </div>
  );
}
